import React from 'react';
import {t} from "../../../i18n";

interface PickUpBolCardProps {
    // 签字状态，后端契约就绪后由页面传入
    signed?: boolean;
    // 标题下的一行橙色小字，仅在需要司机处理时传（如签字失效需重签）
    note?: string;
    onClick?: () => void;
}

// 揽收成功页 BOL 提货单入口
const PickUpBolCard: React.FC<PickUpBolCardProps> = ({signed = false, note, onClick}) => {
    return (
        <div className="mb-1 bg-white rounded-lg p-4 shadow-sm">
            <h2 className={`text-base font-semibold ${note ? 'mb-1' : 'mb-3'}`}>{t('pages.pickUp.pickedUp.bolTitle')}</h2>
            {note && <div className="text-xs text-orange-500 mb-3">{note}</div>}
            <div className="flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 p-3.5" onClick={onClick}>
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" className="shrink-0" style={{color: 'var(--adm-color-primary)'}}>
                    <path d="M5 2h10l4 4v16H5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
                    <path d="M15 2v4h4" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
                    <path d="M8 12h8M8 16h8" stroke="currentColor" strokeWidth="1.2"/>
                </svg>
                <div className="flex-1">
                    <div className="text-sm font-medium">{t('pages.pickUp.pickedUp.bolDocument')}</div>
                    <div className={`text-xs mt-0.5 ${signed ? 'text-[#3BA35A]' : 'text-gray-400'}`}>
                        {t(`pages.pickUp.pickedUp.${signed ? 'bolSigned' : 'bolUnsigned'}`)}
                    </div>
                </div>
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" className="shrink-0 text-gray-300">
                    <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        </div>
    );
};

export default PickUpBolCard;
